import { validatePhoneNumber } from '@ztechapps/common.utils'

export const validateWithPhone = (values) => {
  const errors: any = {}

  if (!values.phone) {
    errors.phone = 'Required.'
  } else {
    //check if the length is more than 10 chars
    try {
      validatePhoneNumber(values.phone)
    } catch (e) {
      errors.phone = e.message
    }
  }

  return errors
}
